import { WebCamera } from './WebCamera';
import { CameraProps } from '@/types/camera';

// Usar WebCamera em todas as plataformas para comportamento consistente
// Funciona perfeitamente em iOS/Android WebView com suporte a vídeo
export const CameraCapture = (props: CameraProps) => {
  return <WebCamera {...props} />;
};
